export default __webpack_public_path__ + "static/media/Pinpoint Shot.eb53d837.png";